import Vue from 'vue'

const PATH = `${process.vars.BACKEND_HOST}/api/ui/assignment_terms`

export default {
  all (conditions) {
    return Vue.http.get(PATH, {
      params: {
        vendor_id: conditions.vendorId,
        product_id: conditions.productId,
        contract_id: conditions.contractId,
        id: conditions.assignmentTermId
      }
    })
  },

  update (id, params) {
    return Vue.http.put(`${PATH}/${id}`, {
      assignment_term: {
        name: params.name,
        buying_probability: params.buyingProbability,
        lead_price: params.leadPrice,
        one_seller_price: params.oneSellerPrice,
        two_sellers_price: params.twoSellersPrice,
        three_sellers_price: params.threeSellersPrice,
        radius: params.radius,
        auto_assignment_ranking: params.autoAssignmentRanking,
        ordered_dates_type: params.orderedDatesType,
        feedback_time: params.feedbackTime,
        contingent_attributes: {
          id: params.contingentForm.id,
          daily: params.contingentForm.daily,
          weekly: params.contingentForm.weekly,
          monthly: params.contingentForm.monthly
        },
        contingent_amount_diff: {
          daily_remain: params.contingentForm.dailyRemainDiff,
          weekly_remain: params.contingentForm.weeklyRemainDiff,
          monthly_remain: params.contingentForm.monthlyRemainDiff,
          unique_remain: params.contingentForm.uniqueRemainDiff
        },
        pricing_attributes: {
          id: params.pricingId,
          setting: params.pricingSetting
        }
      }
    })
  }
}
